import moment from 'moment-timezone'
/** @deprecated Moment-timezone usage. bundle size huge increase */
class TimeConverter {
  dateObject(date: moment.Moment) {
    return {
      year: date.year(),
      month: date.month(),
      day: date.date(),
      hours: date.hours(),
      minutes: date.minutes(),
    }
  }

  convertTimezoneFromLocal(date: moment.Moment | number, timezone: string) {
    date = moment(date)
    const obj = this.dateObject(date)
    return moment.tz(obj, timezone)
  }

  convertTimezoneToLocal(date: moment.Moment | number, timezone: string) {
    date = moment.tz(date, timezone)
    const obj = this.dateObject(date)
    return moment(obj)
  }
}

export default new TimeConverter()
